export const environment = {
  appUrl: 'http://localhost:4200',
  version: '1.0.16',
  production: false,
  stripePublishableKey: 'pk_test_51TWuw0CNKJ53fLhCGO1MENMt38DUw9lbsJC4YRmUYMgs1SCPC1ySBDa0RnomrshXPisHckNK9w86CIXK0KnLGpwV007BhfaF8d',
  firebase: {
    //Staging
    apiKey: "AIzaSyDmL6E1W8BLH_1qgxJwOyYlR7t8ZEc4QD0",
    authDomain: "alynmaster-6a727.firebaseapp.com",
    projectId: "alynmaster-6a727",
    storageBucket: "alynmaster-6a727.firebasestorage.app",
    messagingSenderId: "879654762801",
    appointmentId: "1:879654762801:web:b93d248b4aab58d1911810",
    measurementId: "G-LF865G8386",
    databaseURL: "https://alynmaster-6a727-default-rtdb.firebaseio.com"


    //live
    // apiKey: "AIzaSyBnrfWJDTn8fWTEhcQ4zpzriQfjDObTUZc",
    // authDomain: "aluguloo-b1e1b.firebaseapp.com",
    // databaseURL: "https://aluguloo-b1e1b-default-rtdb.firebaseio.com",
    // projectId: "aluguloo-b1e1b",
    // storageBucket: "aluguloo-b1e1b.firebasestorage.app",
    // messagingSenderId: "1042270373448",
    // appId: "1:1042270373448:web:2f1d3f1a64cb84d00e3a7d",
    // measurementId: "G-EKBN5WZ2G5"
  },
};
